import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { LoggerService, TaggedLogger } from '../../services/index';
import { getCombinedParameters } from '../../utils/getCombinedParameters';

/**
 * Job Component, used to universal/app link to the mobile app to a particular job.
 *
 * The job should be buyable/watchable/ignorable.
 */
@Component({
  selector: 'app-job',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./job.component.scss'],
  templateUrl: './job.component.html',
})
export class JobComponent {
  private readonly logger: TaggedLogger;

  id = '';

  constructor(private route: ActivatedRoute, logger: LoggerService) {
    this.logger = logger.taggedLogger('component:job');
  }

  ngOnInit() {
    this.logger.debug('ngOnInit');
    getCombinedParameters(this.route).subscribe((params: Params) => {
      this.logger.debug('Got job id:', params['id']);
      this.id = params['id'];
      // todo: later on we'll load a page here that acts like the mobile app page.
    });
  }
}
